/** Upper bound for large-phone layouts (e.g. legacy iPhones, Samsung S20 Ultra class). */
export const MOBILE_LAYOUT_MAX_WIDTH_PX = 430;

export const PRODUCT_TYPES = {
  STANDARD: 'standard',
  DIGITAL: 'digital',
};

export const CURRENCIES = [
  { value: 'USD', label: 'USD' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
  { value: 'CAD', label: 'CAD' },
  { value: 'AUD', label: 'AUD' },
];

export const PAYMENT_PROVIDERS = {
  STRIPE: 'stripe',
  PAYPAL: 'paypal',
};

export const PAYMENT_PROVIDERS_ENUM = {
  UNKNOWN: 0,
  FREE: 1,
  TEST: 2,
  CASHONDELIVERY: 3,
  PAYPAL: 10,
  STRIPE: 11,
  MOLLIE: 12,
  PAYUBIZ: 13,
  PAGSEGURO: 14,
  PAYPALFORPARTNER: 15,
};

export const STRIPE_FEES = {
  PERCENTAGE: 2.9,
  FIXED: 0.30,
};

export const PAYPAL_FEES = {
  PERCENTAGE: 2.59,
  FIXED: 0.49,
};

export const FILE_TYPE_LIMITS = {
  IMAGE: {
    extensions: ['.jpg', '.jpeg', '.png', '.gif'],
    maxBytes: 4 * 1024 * 1024,
    label: '4MB',
  },
  AUDIO: {
    extensions: ['.wav', '.flac', '.mp3', '.m4a', '.aac', '.oga'],
    maxBytes: 100 * 1024 * 1024,
    label: '100MB',
  },
  VIDEO: {
    extensions: [
      '.avi', '.mpeg', '.mpg', '.mpe', '.mp4', '.flv', '.webm', '.mov', '.ogv',
      '.m4v', '.3gp', '.divx', '.xvid', '.mxf', '.wmv',
    ],
    maxBytes: 1024 * 1024 * 1024,
    label: '1GB',
  },
  DOCUMENT: {
    extensions: [
      '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.odt', '.odp', '.pdf',
      '.epub', '.rtf', '.txt',
    ],
    maxBytes: 40 * 1024 * 1024,
    label: '40MB',
  },
  ZIP: {
    extensions: ['.zip'],
    maxBytes: 1024 * 1024 * 1024,
    label: '1GB',
  },
};

export const FILE_UPLOAD_LIMITS = {
  IMAGE: FILE_TYPE_LIMITS.IMAGE.maxBytes,
  DOCUMENT: FILE_TYPE_LIMITS.DOCUMENT.maxBytes,
  AUDIO: FILE_TYPE_LIMITS.AUDIO.maxBytes,
  ZIP: FILE_TYPE_LIMITS.ZIP.maxBytes,
};

export const ALLOWED_FILE_TYPES = {
  IMAGE: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'],
  DOCUMENT: ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
  AUDIO: ['audio/mpeg', 'audio/wav', 'audio/mp3'],
  ZIP: ['application/zip', 'application/x-zip-compressed'],
};

export const BLOCKED_FILE_TYPES = ['.dat', '.exe'];

